export const INVOICE_STATUS_PENDING = 'pending';
export const INVOICE_STATUS_PAID = 'paid';
export const INVOICE_STATUS_CANCELED = 'canceled';
